import { AnyAction, Reducer } from "redux";
import * as userProfileActions from "./userProfileActions";

export interface UserProfileState {
  upsertVoucherPopupVisible: boolean;
  upsertVoucherPopupId: string;
}

const initialState: UserProfileState = {
  upsertVoucherPopupVisible: false,
  upsertVoucherPopupId: "",
};

type SupportedActions =
  | userProfileActions.UpsertVoucherPopupVisibleAction
  | AnyAction;

export const userProfileReducer: Reducer<UserProfileState> = (
  state = initialState,
  action: SupportedActions
) => {
  switch (action.type) {
    case userProfileActions.UPSERT_VOUCHER_POPUP_VISIBLE_ACTION:
      return {
        ...state,
        upsertVoucherPopupId: action.id,
        upsertVoucherPopupVisible: action.isVisible,
      };
    default: {
      return state;
    }
  }
};
